import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const CheckedIcon = ({ fill = '#28B57A', width = 12, height = 14 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 9"
        fill="none"
    >
        <path
            d="M4.37045 9C4.14729 9.0004 3.92626 8.95778 3.72004 8.8746C3.51381 8.79142 3.32647 8.66931 3.16877 8.51529L0 5.42465L0.801116 4.64259L3.96989 7.73378C4.07613 7.8374 4.22022 7.8956 4.37045 7.8956C4.52068 7.8956 4.66476 7.8374 4.771 7.73378L12.6989 0L13.5 0.781503L5.57212 8.51529C5.41442 8.66931 5.22708 8.79142 5.02086 8.8746C4.81464 8.95778 4.5936 9.0004 4.37045 9Z"
            fill={fill}
        />
    </svg>
);
